import { Component, OnInit, HostListener} from "@angular/core";
import { AcompanhamentoBatchService } from '../acompanhamento-batch.service';
import { DatePipe } from '@angular/common';
import { ControleAgendamentoProcessoHonraBatch } from 'src/app/model/controle-agendamento-processo-batch.model';
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: 'app-acompanhamento-batch-pesquisa',
    templateUrl: './acompanhamento-batch-pesquisa.component.html',
    styleUrls: ['./acompanhamento-batch-pesquisa.component.scss'],
    standalone: false
})
export class AcompanhamentoBatchPesquisaComponent implements OnInit {

  public controleAgendamentoProcessoHonraBatch: ControleAgendamentoProcessoHonraBatch[];
  public pesquisado: boolean = false;
  public nomeJanela: Date;
  public execucaoRealizadaComSucessoTrue: number = 0;
  public controleAgendamentoProcessoHonraBatchLength: number;
  public logsExecucaoLength: number;
  public progresso: number;

  @HostListener('window:keydown.enter', ['$event'])
  keyEvent(event: KeyboardEvent) {
    this.buscarTodos()
  }
  
  constructor(
    private service: AcompanhamentoBatchService,
    private datePipe: DatePipe,
    private route: ActivatedRoute  
  ){}

  ngOnInit(): void {
    const params = this.route.snapshot.queryParams;

    if (params['nomeJanela']) {
      this.nomeJanela = this.tratarData(params['nomeJanela']);
      this.buscarTodos();
    }
  }


  public buscarTodos() {
    if (this.nomeJanela) {
      const params: any = {};
      params.nomeJanela = this.datePipe.transform(this.nomeJanela, 'MM/yyyy');

      this.service.buscarAgendamentoHonra(params)
        .subscribe((res: any) => {
          this.controleAgendamentoProcessoHonraBatch = res;
          this.pesquisado = true
          this.calculaProgresso();
          // console.log("controleAgendamentoProcessoHonraBatchLength: "+ this.controleAgendamentoProcessoHonraBatchLength)
          // console.log("execucaoRealizadaComSucessoTrue: "+ this.execucaoRealizadaComSucessoTrue)
          // console.log("progresso: "+ this.progresso)
        })
        this.execucaoRealizadaComSucessoTrue = 0; // zera para a próxima pesquisa
    }
  }

  calculaProgresso(){
    this.controleAgendamentoProcessoHonraBatchLength = Object.keys(this.controleAgendamentoProcessoHonraBatch).length
    for (var i=0; i<this.controleAgendamentoProcessoHonraBatchLength;i++){
      this.controleAgendamentoProcessoHonraBatch[i].sucesso == true? this.execucaoRealizadaComSucessoTrue++ : ''
    }
    this.progresso = ((this.execucaoRealizadaComSucessoTrue / this.controleAgendamentoProcessoHonraBatchLength) * 100); 
    this.progresso = Math.round(this.progresso)
  }

  tratarData(data: string): Date {
    const [mes, ano] = data.split('/').map(Number);
    return new Date(ano, mes - 1, 1);
  }

  public limpar() {
    this.nomeJanela = null;
  }
}
